import * as React from 'react';

import {Card} from 'shells/card/card';
import {EmptyAddCard} from 'shells/card/empty-add-card';
import {colors} from 'shells/colors/colors';
// @ts-expect-error - imported from .js/.jsx file
import {PlayButtonIcon} from 'shells/icon/svg/play-button-icon';
import {TwoLine} from 'shells/two-line/two-line';
import {TwoLineButtonCard} from 'shells/two-line/two-line-button-card';

import type {
    GetDripSequence_campaign_startTrigger as StartTriggerFragment,
    GetSmsDripSequence_smsDripSequence_startTrigger as SmsStartTriggerFragment,
} from 'nutshell-graphql-types';

import {getColor, getIcon} from '../drip-sequence-page/color-icon-variants';
import type {Variant} from '../drip-sequence-page/color-icon-variants';

import styles from './start-trigger-card.module.css';

type Props = {
    startTrigger: StartTriggerFragment | SmsStartTriggerFragment | null | undefined;
    isLoading: boolean;
    shouldShowEmptyState?: boolean;
    isActive: boolean;
    onClick?: (startTriggerId: string) => void;
    variant?: Variant;
};

export function StartTriggerCard(props: Props) {
    const {startTrigger, isActive, shouldShowEmptyState, onClick} = props;

    const color = getColor(props.variant, colors.lead);
    const icon = getIcon(props.variant, PlayButtonIcon);

    // This is only used in the prepare to active modal, not on the drip sequence page
    if (shouldShowEmptyState) {
        return (
            <Card borderColor={color} hasBorder={true}>
                <div className={styles['empty-start-trigger']}>
                    <TwoLine
                        icon={icon}
                        iconSize={20}
                        iconColor={color}
                        topRow='No start trigger configured'
                        bottomRow='Only people manually added to this drip sequence will receive messages'
                        isLargeWithSmallBottomRow={true}
                    />
                </div>
            </Card>
        );
    }

    if (startTrigger && !props.isLoading) {
        return (
            <TwoLineButtonCard
                // @ts-expect-error
                borderColor={color}
                onClick={onClick ? () => onClick(startTrigger.id) : undefined}
            >
                <TwoLine
                    icon={icon}
                    iconSize={20}
                    iconColor={color}
                    topRow={
                        <span>
                            <b>Start trigger:</b>&nbsp;{startTrigger.humanReadableTitle}
                        </span>
                    }
                    bottomRow={
                        isActive ? (
                            startTrigger.humanReadableSubtitle
                        ) : (
                            <p style={{color: color}} className={styles['uneditable-text']}>
                                This start trigger is no longer active
                            </p>
                        )
                    }
                    isLargeWithSmallBottomRow={true}
                />
            </TwoLineButtonCard>
        );
    }

    return (
        <div className={styles['add-trigger-container']}>
            <EmptyAddCard
                onClick={onClick ? () => onClick('NEW') : () => {}}
                text='Add a start trigger'
                background='white'
                size='small'
                withoutIcon={true}
                color={color}
                isLoading={props.isLoading}
            />
        </div>
    );
}
